import {Reducers} from './dataEnum';

export const SHOW_MODAL = `${Reducers.MODAL_STORE}/SHOW_MODAL`;
export const HIDE_MODAL = `${Reducers.MODAL_STORE}/HIDE_MODAL`;
export const SHOW_POPUP = `${Reducers.MODAL_STORE}/SHOW_POPUP`;
export const HIDE_POPUP = `${Reducers.MODAL_STORE}/HIDE_POPUP`;
export const SHOW_KEYBOARD = `${Reducers.MODAL_STORE}/SHOW_KEYBOARD`;
export const HIDE_KEYBOARD = `${Reducers.MODAL_STORE}/HIDE_KEYBOARD`;
export const SHOW_LOADSETUP = `${Reducers.MODAL_STORE}/SHOW_LOADSETUP`;
export const SHOW_HARDWARE_CHECKUP = `${Reducers.MODAL_STORE}/SHOW_HARDWARE_CHECKUP`;
export const UPDATE_HARDWARE_CHECK_UP_BUTTON = `${Reducers.MODAL_STORE}/UPDATE_HARDWARE_CHECK_UP_BUTTON`;
export const RUN_HARDWARE_CHECK_UP = `${Reducers.MODAL_STORE}/RUN_HARDWARE_CHECK_UP`;
export const PAUSED_HARDWARE_CHECK_UP = `${Reducers.MODAL_STORE}/PAUSED_HARDWARE_CHECK_UP`;
export const UPDATE_HARDWARE_LIST = `${Reducers.MODAL_STORE}/UPDATE_HARDWARE_LIST`;
export const UPDATE_HARDWARE_CHECK_UP_STATE = `${Reducers.MODAL_STORE}/UPDATE_HARDWARE_CHECK_UP_STATE`;
